module.exports = __webpack_public_path__ + "img/text3.136c218a.png";